import { Role } from "@app/constants";
import { AppAction } from "@core/types/redux.type";
import { MyInfoActionType, MyInfoEpicType, MyInfoState } from "./my-info.type";

export default function myInfoReducer(
  state = initialState,
  action: AppAction
): MyInfoState {
  switch (action.type) {
    case MyInfoEpicType.FETCH_MY_INFO:
      return {
        ...state,
        isMyInfoLoading: true,
        isMyInfoError: false,
      };
    case MyInfoActionType.STORE_MY_INFO:
      return {
        ...state,
        myInfo: {
          _id: action.payload?.myInfo?._id,
          username: action.payload?.myInfo?.username,
          fullName: action.payload?.myInfo?.fullName,
          email: action.payload?.myInfo?.email,
          isActive: action.payload?.myInfo?.isActive,
          phone: action.payload?.myInfo?.phone,
          balance: action.payload?.myInfo?.balance ?? 0,
          imageAllowed: action.payload?.myInfo?.imageAllowed ?? 0,
          kyc: action.payload?.myInfo?.kyc,
          isVerify: action.payload?.myInfo?.isVerify,
          isSigned: action.payload?.myInfo?.isSigned ?? false, // 👈 Thêm trạng thái đã ký
          is_up: action.payload?.myInfo?.is_up, // 👈 Trạng thái đã up bản khai/hợp đồng
          id_card:
            action.payload?.myInfo?.id_card ?? action.payload?.myInfo?.id, // 👈 Số CCCD/CMND
          dob: action.payload?.myInfo?.dob, // 👈 Ngày sinh
          issueDate: action.payload?.myInfo?.issueDate, // 👈 Ngày cấp CCCD
          issuePlace: action.payload?.myInfo?.issuePlace, // 👈 Nơi cấp CCCD
          address: action.payload?.myInfo?.address, // 👈 Địa chỉ thường trú
          front_card: action.payload?.myInfo?.front_card,
          back_card: action.payload?.myInfo?.back_card,
          portrait: action.payload?.myInfo?.portrait,
          link_contract: action.payload?.myInfo?.link_contract,
          otp: action.payload?.myInfo?.otp,
          timeKyc: action.payload?.myInfo?.timeKyc,
          role: action.payload?.myInfo?.role,
          reasonFailKyc: action.payload?.myInfo?.reasonFailKyc,
          discount_pc: action.payload?.myInfo?.discount_pc,
          discount_vps: action.payload?.myInfo?.discount_vps,
          discount_cloud: action.payload?.myInfo?.discount_cloud,
          createdAt: action.payload?.myInfo?.createdAt,
          updatedAt: action.payload?.myInfo?.updatedAt,
          province: action.payload?.myInfo?.province,
          ward: action.payload?.myInfo?.ward,
          addressDetail: action.payload?.myInfo?.addressDetail,
          numberEkycFail: action.payload?.myInfo?.numberEkycFail,
          isRequestVerifyPhone: action.payload?.myInfo?.isRequestVerifyPhone,
          isVerifyPhone: action.payload?.myInfo?.isVerifyPhone,
          otpVerifyPhone: action.payload?.myInfo?.otpVerifyPhone,
          timeOtpVerifyPhone: action.payload?.myInfo?.timeOtpVerifyPhone,
        },
        isMyInfoLoading: false,
        isMyInfoError: false,
      };
    case MyInfoActionType.CLEAR_MY_INFO:
      return {
        ...initialState,
        isMyInfoLoading: false,
      };
    case MyInfoActionType.FETCH_MY_INFO_FAILED:
      return {
        ...state,
        isMyInfoLoading: false,
        isMyInfoError: true,
      };
    default:
      return state;
  }
}

const initialState: MyInfoState = {
  myInfo: {
    _id: "",
    username: "",
    fullName: "",
    email: "",
    isActive: 0,
    phone: "",
    balance: 0,
    imageAllowed: 0,
    kyc: 0,
    isVerify: 0,
    isSigned: false, // 👈 Khởi tạo mặc định
    is_up: 0, // 👈 Khởi tạo mặc định
    id_card: "", // 👈 Khởi tạo mặc định
    dob: "", // 👈 Khởi tạo mặc định
    issueDate: "", // 👈 Khởi tạo mặc định
    issuePlace: "", // 👈 Khởi tạo mặc định
    address: "", // 👈 Khởi tạo mặc định
    front_card: "",
    back_card: "",
    portrait: "",
    link_contract: "",
    otp: "",
    timeKyc: "",
    role: Role.USER,
    reasonFailKyc: "",
    discount_pc: 0,
    discount_vps: 0,
    discount_cloud: 0,
    createdAt: "",
    updatedAt: "",
    province: "",
    ward: "",
    addressDetail: "",
    numberEkycFail: 0,
    isRequestVerifyPhone: 0,
    isVerifyPhone: 0,
    otpVerifyPhone: "",
    timeOtpVerifyPhone: 0,
  },
  isMyInfoLoading: true,
  isMyInfoError: false,
};
